import styled, { css } from 'styled-components';
import { mq, px2rem, getSpace, getGridSpan } from '../../../stylesheets/tools';

const StyledTeaserContainer = styled.div`
  margin: ${getSpace('xxl')} 0;

  .teaserContainer__container {
    ${props =>
      props.topMargin &&
      css`
        margin-top: ${px2rem('125px')};
      `}
    .container__wrapper {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
    }

    ${props =>
      props.teaserLength !== 3 &&
      css`
        ${mq('m')} {
          .teaserContainer__teaser:nth-of-type(odd) {
            margin-right: ${px2rem('10px')};
          }

          .teaserContainer__teaser:nth-of-type(even) {
            margin-top: ${getSpace('xxxl')};
          }
        }
      `}

    ${props =>
      props.teaserLength === 3 &&
      css`
        .container__wrapper {
          justify-content: center;
        }

        .teaserContainer__teaser:first-of-type {
          margin-top: ${getSpace('l')};
          margin-bottom: ${getSpace('110px')};
          margin-right: 1px;
        }

        .teaserContainer__teaser {
          margin-top: 30px;
          margin-bottom: 30px;
        }

        ${mq('m')} {
          .teaserContainer__teaser:nth-of-type(2) {
            margin-top: 0;
            margin-right: 10px;
          }
          .teaserContainer__teaser:nth-of-type(3) {
            margin-top: ${getSpace('xxxl')};
          }
        }
      `}
  }
`;

const StyledTeaserContainerSkeleton = styled.div`
  margin: ${getSpace('xxxl')} 0;

  .skeleton-wrapper {
    position: relative;
    display: flex;
    flex-wrap: wrap;

    span {
      display: block;
      margin-bottom: 20px;
      padding-bottom: calc((3 / 4) * 100%);
      width: ${getGridSpan(12, 'normal')};
      border: 5px solid black;

      ${mq('m')} {
        padding-bottom: calc((2 / 4) * 100%);
        width: ${getGridSpan(8, 'normal')};
        margin-left: ${getGridSpan(2, 'spread')};
      }

      &:nth-of-type(2),
      &:nth-of-type(3) {
        display: inline-block;
        padding-bottom: calc((4 / 3) * 100%);
        width: ${getGridSpan(12, 'normal')};
        margin-top: ${getSpace('xl')};
        margin-left: 0;

        ${mq('m')} {
          margin-right: ${getGridSpan(1, 'spread')};
          padding-bottom: calc((2 / 4) * 100%);
          width: ${getGridSpan(5, 'normal')};
        }
      }

      &:nth-of-type(3) {
        transform: translateY(${getSpace('xxxl')};);
      }
    }
  }
`;

export { StyledTeaserContainer, StyledTeaserContainerSkeleton };
